import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {getNumbers} from '../../store/actions';
import NumberField from './NumberField';
import DropDown from './DropDown';
import randomIcon from '../../assets/ic_random.svg';
import './styles.css';
import Loadable from 'react-loadable';
import LoadGif from '../../assets/loader_alternative.gif';

const NumberForm = props => {
    const [numberVal, setNumber] = useState('');
    const [prefix, setPrefix] = useState('');
    const [searchVal, setSearch] = useState('');

    useEffect(() => {
        props.getNumbers(null, 1);
    }, ['mount']);

    const LoadableBar = Loadable({
        loader: () => import('../NumberList/numberList'),
        loading() {
            return (
        <div className="preloader-block">
          <img className="img-preloader" src={LoadGif} alt="loading" />
          <div className="text-preloader">Ищем для вас номера...</div>
        </div>
      );
    }
  });
  const search = e => {
    const actionType = numberVal ? 2 : 1;
    e.preventDefault();
    props
      .getNumbers(numberVal.replace(/\D*/g, ''), actionType, prefix)

      .then(() => {
        setSearch(numberVal);
      });
  };
  const randomSearch = () => {
    props.getNumbers(null, 1);
  };
  const SearchFound = () => {
    return (
      <div className="number-not-found">
        <div className="number-info">
          Номер
          <span>
            {prefix} {searchVal}
          </span>
          {props.lang.tryAgain}
        </div>
      </div>
    );
  };
  const SearchOther = () => {
    return (
      <div className="number-not-found">
        <div className="number-info">{props.lang.busyNumber}</div>
      </div>
    );
  };

  return (
    <div className="search">
      <div className="header__bold">
        <h1>{props.lang.title}</h1>
          {/*<img src={SalesLabel} />*/}
      </div>
      <div className="header__caption">{props.lang.caption}</div>
      <div className="search__number-form">
        <DropDown
          text={props.lang.prefix}
          mobileText={props.lang.mobilePrefix}
          value={prefix}
          onChange={setPrefix}
        />
        <NumberField
          btnText={props.lang.button}
          value={numberVal}
          prefix={prefix}
          onChange={setNumber}
          onSubmit={search}
        />
      </div>
      <div className="search-buttons">
        <button
          className="number-field__btn-mobile click-animate"
          onClick={search}
        >
          {props.lang.button}
        </button>
        <button
          className="search__random-btn click-animate"
          onClick={randomSearch}
        >
          <img src={randomIcon} alt="random-icon" />
          <span>{props.lang.random}</span>
        </button>
      </div>
      {!Object.keys(props.numbers).length ? (
        <LoadableBar />
      ) : props.isNotFinded ? (
          <SearchOther/>
      ) : props.isEmpty ? (
          <SearchFound/>
      ) : (
          ""
      )}
      <LoadableBar searchVal={searchVal} />
    </div>
  );
};

export default connect(
  state => ({
      lang: state.language.numberForm,
      numbers: state.numbers,
      isNotFined: state.alerts,
      isEmpty: state.alerts
  }),
  dispatch => ({
    getNumbers: dispatch(getNumbers)
  })
)(NumberForm);
